import * as types from "../../types/stores.types";

const initialState = {
    status_show_modal: false,
    loader_modal: false,
    code:'',
    link:'',
    text:'',
}
const modalInvitation = (state = initialState, action) => {
    switch (action.type) {
        case types.CHANGE_STATUS_SHOW_MODAL_INVITATION:
            return {...state, status_show_modal: action.payload.status_show_modal};
        case types.CHANGE_LOADER_MODAL_INVITATION:
            return {...state, loader_modal: action.payload.loader_modal};
        case types.PUT_INVITATION_LINK:
            return {...state,code:action.payload.code,link:action.payload.link,text:action.payload.text}
        default:
            return state;
    }
}

export default modalInvitation;